export default __webpack_public_path__ + "static/media/monetizationOnLight.8bbb3753.svg";